import { useIntl } from 'react-intl';

import { SchoolSectionProps } from '@/components/schools/SchoolsLayout/types';

import messages from './messages';
import { Background, CtaButton, Grid, Heading, Wrapper } from './styles';

const ThankYou = ({ onCtaClick }: SchoolSectionProps) => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper>
			<Background src="/_n/images/schools/thanks-collage.webp" />
			<Grid columns={1}>
				<Heading>{formatMessage(messages.heading1)}</Heading>
				<Heading>{formatMessage(messages.heading2)}</Heading>
				<CtaButton backgroundColor="schoolBlue" onPress={() => onCtaClick(messages.heading1.defaultMessage)}>
					{formatMessage(messages.button)}
				</CtaButton>
			</Grid>
		</Wrapper>
	);
};

export default ThankYou;
